import axiosInstance from 'api/axiosInstance';

async function getEmployees() {
	const { data } = await axiosInstance.get(
		'/api/cantrackv3/Consultants?Id=0&SearchKeyword=&Page=1&Take=2147483647',
	);
	// // Consultants?Id=0&SearchKeyword=&Page=1&Take=2147483647
	return data;
}

export default getEmployees;
